<template>
  <div class="my-10">
    <div class="flex justify-center px-4 items-center">
      <h1 class="text-3xl font-bold text-center">
        {{ __("Edit dealership") }}
      </h1>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 ">
      <div class="max-w-2xl w-full mx-auto my-10 flex flex-col items-center">
        <form @submit.prevent="submitForm" class="w-full">
          <div>
            <text-input v-model="form.name" :data-error="error('name')" class="w-full pb-8" :label="__('Name')"/>
            <textarea-input v-model="form.description" :data-error="error('description')" class="w-full pb-8" rows="10" :label="__('Description')"/>
          </div>

          <div class="flex justify-center items-center mt-4">
            <loading-button :loading="sendingForm" class="btn-primary" type="submit">
              {{ __('Save') }}
            </loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import TextInput from '@/Shared/TextInput';
  import TextareaInput from '@/Shared/TextareaInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import Icon from '@/Shared/Icon';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Edit dealership")
      }
    },
    props: {
      dealership: Object
    },
    data() {
      return {
        form: {
          name: this.dealership.name,
          description: this.dealership.description
        },
        sendingForm: false,
      }
    },
    components: {
      Layout,
      TextInput,
      LoadingButton,
      Icon,
      TextareaInput
    },
    methods: {
      submitForm() {
        this.sendingForm = true;
        this.$inertia.put(this.route('dealerships.update', {dealership: this.dealership.slug}), this.form)
          .then(() => {
            this.sendingForm = false;
          });
      }
    }
  }
</script>
